'use strict';

var apis = require('./constants/apis.js');

/**
 * Checks if an HTTP request is successful based on the status code.
 *
 * @param {number} statusCode - The HTTP status code to check.
 * @returns {boolean} True if the status code indicates success, otherwise false.
 */
function isRequestSuccessful(statusCode) {
    return Object.values(apis.HTTP_STATUS_SUCCESS_CODES).includes(statusCode);
}
/**
 * Checks if a given string contains a space character.
 * @param {string} input - The string to check.
 * @returns {boolean} Returns true if the string contains a space, false otherwise.
 */
var checkContainsSpaces = function (_a) {
    var input = _a.input;
    return input.trim().indexOf(" ") > -1;
};
/**
 * Extracts plain text content from an HTML string.
 *
 * @param {string} htmlString - The input HTML string.
 * @returns {string} - The extracted text content.
 */
var extractTextContentFromHtml = function (htmlString) {
    var parser = new DOMParser();
    var doc = parser === null || parser === void 0 ? void 0 : parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
};

exports.checkContainsSpaces = checkContainsSpaces;
exports.extractTextContentFromHtml = extractTextContentFromHtml;
exports.isRequestSuccessful = isRequestSuccessful;
//# sourceMappingURL=common.js.map
